module.exports = __webpack_public_path__ + "static/media/desktop-icon-12-l-track-laptime.14996454.svg";